var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "subForm",
      staticStyle: { "margin-top": "15px" },
      attrs: {
        model: _vm.formData,
        rules: _vm.formRules,
        "label-width": "140px",
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "廠牌", prop: "aiBrand" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "請選擇廠牌", filterable: "" },
              model: {
                value: _vm.formData.aiBrand,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "aiBrand", $$v)
                },
                expression: "formData.aiBrand",
              },
            },
            _vm._l(_vm.aiBrandOptions, function (aiBrand) {
              return _c("el-option", {
                key: aiBrand.value,
                attrs: { label: aiBrand.label, value: aiBrand.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "專案", prop: "project" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "請選擇專案", filterable: "" },
              model: {
                value: _vm.formData.project,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "project", $$v)
                },
                expression: "formData.project",
              },
            },
            _vm._l(_vm.projectOptions, function (project) {
              return _c("el-option", {
                key: project.value,
                attrs: { label: project.label, value: project.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "功能編號", prop: "functionCode" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "請選擇功能編號", filterable: "" },
              model: {
                value: _vm.formData.functionCode,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "functionCode", $$v)
                },
                expression: "formData.functionCode",
              },
            },
            _vm._l(_vm.functionCodeOptions, function (code) {
              return _c("el-option", {
                key: code.value,
                attrs: { label: code.label, value: code.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "功能名稱", prop: "functionName" } },
        [
          _c("el-input", {
            attrs: { placeholder: "請輸入功能名稱" },
            model: {
              value: _vm.formData.functionName,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "functionName", $$v)
              },
              expression: "formData.functionName",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "模型", prop: "useModel" } },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "請選擇 OpenAI 模型", filterable: "" },
              model: {
                value: _vm.formData.useModel,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "useModel", $$v)
                },
                expression: "formData.useModel",
              },
            },
            _vm._l(
              _vm.filterModelByFunctionCode(_vm.formData.functionCode),
              function (group) {
                return _c(
                  "el-option-group",
                  { key: group.label, attrs: { label: group.label } },
                  _vm._l(group.options, function (model) {
                    return _c("el-option", {
                      key: model.value,
                      attrs: { label: model.label, value: model.value },
                    })
                  }),
                  1
                )
              }
            ),
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "功能類型" } },
        [
          _c(
            "el-checkbox-group",
            {
              model: {
                value: _vm.formData.functionTypes,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "functionTypes", $$v)
                },
                expression: "formData.functionTypes",
              },
            },
            [
              _c("el-checkbox", { attrs: { label: "文字分析" } }),
              _c("el-checkbox", { attrs: { label: "生成圖片" } }),
              _c("el-checkbox", { attrs: { label: "影像辨識" } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showPromptField
        ? _c(
            "el-form-item",
            { attrs: { label: "提示詞" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 5,
                  placeholder: "請輸入 AI Agent 的 提示詞 (Prompt)...",
                  resize: "vertical",
                },
                model: {
                  value: _vm.formData.prompt,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "prompt", $$v)
                  },
                  expression: "formData.prompt",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.formData.functionTypes.includes("生成圖片")
        ? _c(
            "el-form-item",
            { attrs: { label: "輸出圖片尺寸" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "請選擇尺寸" },
                  model: {
                    value: _vm.formData.outputResolution,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "outputResolution", $$v)
                    },
                    expression: "formData.outputResolution",
                  },
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: "1024 × 1024 (正方形 1:1)",
                      value: "1024x1024",
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: "1792 × 1024 (橫式 16:9)",
                      value: "1792x1024",
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: "1024 × 1792 (直式 9:16)",
                      value: "1024x1792",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "form-tip" }, [
                _vm._v("※ 依據 OpenAI 官方建議之長寬比例進行輸出。"),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.formData.functionTypes.includes("生成圖片")
        ? _c(
            "el-form-item",
            { attrs: { label: "圖片生成解析度" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.formData.outputImageQuality,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "outputImageQuality", $$v)
                    },
                    expression: "formData.outputImageQuality",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "low" } }, [
                    _vm._v("低品質 (Low)"),
                  ]),
                  _c("el-radio-button", { attrs: { label: "medium" } }, [
                    _vm._v("中品質 (Medium)"),
                  ]),
                  _c("el-radio-button", { attrs: { label: "hd" } }, [
                    _vm._v("高品質 (HD)"),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "form-tip" }, [
                _vm._v(
                  "※ HD 品質會消耗較多 Token，但畫面細節、材質與光影表現會顯著提升。"
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.formData.functionTypes.includes("影像辨識")
        ? _c(
            "el-form-item",
            { attrs: { label: "辨識採樣率 (DPI)" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "請選擇 DPI 轉換規格" },
                  model: {
                    value: _vm.formData.convertDpi,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "convertDpi", $$v)
                    },
                    expression: "formData.convertDpi",
                  },
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: "72 DPI (螢幕預覽低解析度 - 速度極快)",
                      value: 72,
                    },
                  }),
                  _c("el-option", {
                    attrs: { label: "100 DPI (網頁影像輕量化)", value: 100 },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: "150 DPI (標準 OCR 文字辨識推薦 - 速度與精準平衡)",
                      value: 150,
                    },
                  }),
                  _c("el-option", {
                    attrs: { label: "200 DPI (清晰文件與傳真)", value: 200 },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: "300 DPI (高精細印刷品 / 複雜表格 / 手寫字辨識)",
                      value: 300,
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: "400 DPI (細微線條與小字特殊辨識)",
                      value: 400,
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: "600 DPI (醫療影像 / 高端檔案數位化存檔)",
                      value: 600,
                    },
                  }),
                  _c("el-option", {
                    attrs: {
                      label: "1000 DPI (超高解析度精密採樣 - 轉圖耗時較長)",
                      value: 1000,
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "form-tip" }, [
                _vm._v(
                  "※ 控制後端將 PDF/影像轉圖至 AI 辨識時的像素採樣密度 (DPI)。"
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }